module.exports = __webpack_public_path__ + "img/intro.0a659c20.jpg";